module.exports = __webpack_public_path__ + "img/crown_3.a5bfcb13.svg";